import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map, timeout } from 'rxjs/operators';
import { LIB_CONFIG, LibConfig } from '../../lib.config';

@Injectable()
export class GeocodeService {
  private readonly config = inject<LibConfig>(LIB_CONFIG);

  private readonly http: HttpClient;

  constructor() {
    const backend = inject(HttpBackend);

    // Manuelle Konstruktion des Clients, um die BaOauthLib, die ungewünschte
    // Header hinzufügt, zu umgehen.
    this.http = new HttpClient(backend);
  }

  public getCoordinates(
    street: string,
    zipcode: string,
    city: string
  ): Observable<{ x: string; y: string }> {
    const address = {
      OBJECTID: 1,
      Address: street,
      Postal: zipcode,
      City: city,
      Strasse: street, //TODO nach PRV 25.11 Release entfernen, da breaking-change in geois api
      PLZ: zipcode, //TODO nach PRV 25.11 Release entfernen, da breaking-change in geois api
      Ort: city //TODO nach PRV 25.11 Release entfernen, da breaking-change in geois api
    };
    const records = JSON.stringify({ records: [{ attributes: address }] });
    const parameters = { f: 'pjson', addresses: records };

    return this.http
      .get(this.config.geois.geoisGeocodeServer + '/geocodeAddresses', {
        params: parameters,
        withCredentials: true
      })
      .pipe(
        timeout(4000),
        map((response) => {
          const res = <any>response;

          if (
            !res.locations ||
            res.locations[0].location.x === 'NaN' ||
            res.locations[0].location.y === 'NaN'
          ) {
            throw new Error('Keine bekannte Location!');
          }

          return { x: res.locations[0].location.x, y: res.locations[0].location.y };
        })
      );
  }
}
